/**
 * API Configuration
 * Centralized API endpoint configuration for the application
 */

const browserDefaultApiUrl = typeof window === 'undefined'
  ? 'http://127.0.0.1:8000'
  : `${window.location.protocol}//${window.location.hostname}:8000`;

const browserSameOriginApiUrl = typeof window === 'undefined'
  ? 'http://127.0.0.1'
  : window.location.origin;

const appEnv = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
const isProductionBuild = appEnv === 'production';

const resolvedApiUrl = process.env.REACT_APP_API_URL
  || (isProductionBuild ? browserSameOriginApiUrl : browserDefaultApiUrl);

if (isProductionBuild && !process.env.REACT_APP_API_URL) {
  console.warn('REACT_APP_API_URL is not set for production; defaulting API base to same origin.');
}

export const API_URL = resolvedApiUrl.replace(/\/$/, '');

/**
 * API Endpoints
 */
export const ENDPOINTS = {
  SUMMARIZE: '/summarize',
  SUMMARIZE_STREAM: '/summarize/stream',
  REGENERATE: '/regenerate',
  REGENERATE_STREAM: '/regenerate/stream',
  PARSE_DOCUMENT: '/parse_document',
  PROMPTS: '/prompts',
  PROMPTS_CUSTOM: '/prompts/custom',
  ENHANCE_USE_CASE: '/prompts/enhance-use-case',
  EXPORT: '/export',
  MODELS: '/models',
  EXTRACT_METADATA: '/extract-metadata',
  SUGGESTIONS: '/suggestions',
  SUGGESTIONS_APPLY: '/suggestions/apply',
  EDIT_SELECTION: '/edit_selection',
  SHORTEN: '/shorten',
  SIMPLIFY: '/simplify',
  REPHRASE: '/rephrase',
};

/**
 * Build full API URL
 * @param {string} endpoint - The endpoint path
 * @returns {string} Full URL
 */
export const buildApiUrl = (endpoint) => {
  return `${API_URL}${endpoint}`;
};

/**
 * Common fetch options
 */
export const defaultFetchOptions = {
  headers: {
    'Content-Type': 'application/json',
  },
};
